export default "__VITE_ASSET__6INxn2vT__"